//ecd:-997089375H20261022084009_V3.0
import { UserRole } from './UserRole';
import { Address } from './Address';

/**
 * CustomerDTO
 *
 * Generated by ElastiCORE. Do not edit outside the ElastiCORE guidelines.
 */
export interface CustomerDTO {

    role?: UserRole;
    
    homeAddress: Address;
    
    customerId?: number;
    
    login: string;
    
    password?: string;
    
    firstName: string;
    
    lastName: string;
    
    telephone?: string;
    
    email?: string;
    
    dateOfBirth?: string;
}

/** Each field's label and limits, as the DSL declares them. */
export const CustomerFields = {
    role: { label: "role" },
    homeAddress: { label: "homeAddress", required: true },
    customerId: { label: "customerId" },
    login: { label: "login", required: true, maxLength: 10 },
    password: { label: "password", required: true, maxLength: 255 },
    firstName: { label: "firstName", required: true, maxLength: 50 },
    lastName: { label: "lastName", required: true, maxLength: 50 },
    telephone: { label: "telephone", maxLength: 30 },
    email: { label: "email", maxLength: 100 },
    dateOfBirth: { label: "dateOfBirth" },
} as const;

/**
 * The DSL's checks, before sending: field -> message, empty when nothing is
 * wrong. The server checks them again; this is so a form can say it first.
 * partial: an update that sends only what changed - what is required is not asked for.
 */
export function validateCustomer(value: Partial<CustomerDTO> | null | undefined, partial = false): Record<string, string> {
    const errors: Record<string, string> = {};
    if (value == null) return errors;
    if (!partial && value.homeAddress == null) errors.homeAddress = "homeAddress is required";
    if (partial ? value.login === '' : (value.login == null || value.login === '')) errors.login = "login is required";
    else if (value.login != null && String(value.login).length > 10) errors.login = "login is at most 10 characters";
    if (partial ? value.password === '' : (value.password == null || value.password === '')) errors.password = "password is required";
    else if (value.password != null && String(value.password).length > 255) errors.password = "password is at most 255 characters";
    if (partial ? value.firstName === '' : (value.firstName == null || value.firstName === '')) errors.firstName = "firstName is required";
    else if (value.firstName != null && String(value.firstName).length > 50) errors.firstName = "firstName is at most 50 characters";
    if (partial ? value.lastName === '' : (value.lastName == null || value.lastName === '')) errors.lastName = "lastName is required";
    else if (value.lastName != null && String(value.lastName).length > 50) errors.lastName = "lastName is at most 50 characters";
    if (value.telephone != null && String(value.telephone).length > 30) errors.telephone = "telephone is at most 30 characters";
    if (value.email != null && String(value.email).length > 100) errors.email = "email is at most 100 characters";
    else if (value.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(String(value.email))) errors.email = 'Email format invalid';
    return errors;
}
